import { Action } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, from } from 'rxjs';
import { catchError, map, withLatestFrom, filter, exhaustMap } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import type { GetProductsResponse } from '@dtp/membership-service-types';
import { Actions, actions } from '@redux/modules/products';
import { TypedEpic } from './types';

export const getProductsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_PRODUCTS),
    withLatestFrom(state$),
    filter(([, state]) => !state.products.hasFetched),
    exhaustMap(() =>
      from(
        apiClient.get<GetProductsResponse>(ApiType.apimMembershipApi, {
          url: ApiPaths[ApiType.apimMembershipApi].v2.products,
          skipNafHeaders: true,
        }),
      ).pipe(
        map((response) => actions.getProducts.success(response.data)),
        catchError((err) => of(actions.getProducts.failure(toReduxError(err, GENERIC_FETCH_ERROR_MESSAGE)))),
      ),
    ),
  );

export const epics: TypedEpic[] = [getProductsEpic];
